"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenProviderHandler = void 0;
var tokenprovider_1 = require("@migros/tokenprovider");
var jwt_decode_1 = require("jwt-decode");
var config_1 = require("../config");
var abstractHandler_1 = require("./abstractHandler");
var isAccessToken = function (token) {
    return token.token !== undefined && token.expiresAt !== undefined;
};
var TokenProviderHandler = /** @class */ (function (_super) {
    __extends(TokenProviderHandler, _super);
    function TokenProviderHandler(config) {
        return _super.call(this, config) || this;
    }
    TokenProviderHandler.getUserProfile = function (token, authority) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, fetch("".concat(authority, "/oauth2/userinfo"), {
                                headers: {
                                    Authorization: "Bearer ".concat(token),
                                    Accept: 'application/json',
                                },
                            })];
                    case 1:
                        result = _a.sent();
                        return [4 /*yield*/, result.json()];
                    case 2: 
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                    return [2 /*return*/, _a.sent()];
                    case 3:
                        e_1 = _a.sent();
                        console.error('Error fetching userinfo', e_1);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TokenProviderHandler.prototype.login = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!((_a = this.config.events) === null || _a === void 0 ? void 0 : _a.loginEvent)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.config.events.loginEvent()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    TokenProviderHandler.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!((_a = this.config.events) === null || _a === void 0 ? void 0 : _a.logoutEvent)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.config.events.logoutEvent()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    TokenProviderHandler.prototype.autologin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, newLoginState, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.config.events.autologinEvent) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.config.events.autologinEvent()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        try {
                            (0, tokenprovider_1.getTokenProvider)().onTokenChanged(function (token) {
                                _this.handleTokenChanged(token).catch(function (error) {
                                    _this.loggedIn = false;
                                    _this.publishAuthenticate({
                                        loggedIn: false,
                                        isManualLogin: false,
                                        error: {
                                            message: 'Failed to handle changed token',
                                            code: config_1.ERROR_CODES.LOGIN_SETUP_FAILED,
                                            context: error,
                                        },
                                    });
                                });
                            });
                        }
                        catch (error) {
                            this.loggedIn = false;
                            this.publishAuthenticate({
                                loggedIn: false,
                                isManualLogin: false,
                                error: {
                                    message: 'Failed to configure TokenProvider onTokenChanged',
                                    code: config_1.ERROR_CODES.LOGIN_SETUP_FAILED,
                                    context: error,
                                },
                            });
                            console.error('Failed listening to TokenProvider onTokenChanged event.', error);
                        }
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, (0, tokenprovider_1.getTokenProvider)().getAccessToken()];
                    case 4:
                        token = _b.sent();
                        newLoginState = token ? isAccessToken(token) : false;
                        if (this.loggedIn !== newLoginState) {
                            this.loggedIn = newLoginState;
                            this.publishAuthenticateEvent();
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        _a = _b.sent();
                        if (this.loggedIn !== false) {
                            this.loggedIn = false;
                            this.publishAuthenticateEvent();
                        }
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    TokenProviderHandler.prototype.isLoggedIn = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.resolve(!!this.loggedIn)];
            });
        });
    };
    TokenProviderHandler.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.getAccessToken()];
                    case 1: return [2 /*return*/, (_b = (_a = (_c.sent())) === null || _a === void 0 ? void 0 : _a.token) !== null && _b !== void 0 ? _b : ''];
                }
            });
        });
    };
    TokenProviderHandler.prototype.getUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getAccessToken()];
                    case 1:
                        token = _b.sent();
                        if (!token) {
                            return [2 /*return*/, null];
                        }
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                        return [2 /*return*/, __assign(__assign({}, (((_a = token.payload) === null || _a === void 0 ? void 0 : _a.profile) || token.payload || {})), { id_token: token.token, access_token: token.token, expires_at: token.expiresAt })];
                }
            });
        });
    };
    TokenProviderHandler.prototype.publishAuthenticateEvent = function () {
        this.publishAuthenticate({
            loggedIn: !!this.loggedIn,
            isManualLogin: this.checkIsManualLoginUsingCookie(),
        });
    };
    TokenProviderHandler.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tokenProvider, accessToken, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tokenProvider = (0, tokenprovider_1.getTokenProvider)();
                        accessToken = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, tokenProvider.getAccessToken()];
                    case 2:
                        accessToken = _a.sent();
                        if (!isAccessToken(accessToken)) {
                            return [2 /*return*/, null];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        if ([tokenprovider_1.TokenError.Network, tokenprovider_1.TokenError.Domain].some(function (x) { return x === err_1; })) {
                            return [2 /*return*/, null];
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, accessToken];
                }
            });
        });
    };
    TokenProviderHandler.prototype.handleTokenChanged = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var newLoginState, triggerAuthenticateEvent, decodedToken, profile, _a;
            var _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        newLoginState = token ? isAccessToken(token) : false;
                        triggerAuthenticateEvent = newLoginState !== this.loggedIn;
                        this.loggedIn = newLoginState;
                        if (!token || !isAccessToken(token)) {
                            triggerAuthenticateEvent && this.publishAuthenticateEvent();
                            return [2 /*return*/];
                        }
                        decodedToken = (0, jwt_decode_1.jwtDecode)(token.token);
                        if (!((_d = (_c = (_b = token.payload) === null || _b === void 0 ? void 0 : _b.profile) !== null && _c !== void 0 ? _c : token.payload) !== null && _d !== void 0)) return [3 /*break*/, 1];
                        _a = _d;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, TokenProviderHandler.getUserProfile(token.token, decodedToken.iss)];
                    case 2:
                        _a = (_e.sent());
                        _e.label = 3;
                    case 3:
                        profile = _a;
                        if (!(profile && !token.payload)) return [3 /*break*/, 5];
                        return [4 /*yield*/, (0, tokenprovider_1.getTokenProvider)().setAccessToken(token.token, profile)];
                    case 4:
                        _e.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        this.publishTokenRenew(token.token);
                        triggerAuthenticateEvent && this.publishAuthenticateEvent();
                        _e.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return TokenProviderHandler;
}(abstractHandler_1.AbstractHandler));
exports.TokenProviderHandler = TokenProviderHandler;
